<template>
  <div class="ProperPage">
    <MainPageHeader v-if="!isAndroidContext"/>
    <div v-if="getProductId === '3' || getProductId === '4' || getProductId === '2'"
         :class="{'android-content': isAndroidContext}"
         class="content">
      <header v-if="!isAndroidContext" class="main-header">
        <p v-if="getProductId === '3' || getProductId === '4'" class="font-size-middle">Krok 3 z 3</p>
        <p v-else class="font-size-middle">Krok 3 z 3</p>
      </header>
      <div v-if="!isAndroidContext" class="divider"/>
      <div v-if="!isAndroidContext" class="text-header">
        <h1 class="font-size-big">Płatność odnawialną kartą płatniczą.</h1>
        <p>W dowolnej chwili możesz usunąć kartę w zakładce
          <router-link class="man-acc" to="/manage-access">Zarządzaj dostępem</router-link>
        </p>
      </div>

      <ProperSection class="section-0"
                     :visible="chosenSection === null || chosenSection === 0"
                     :chosen="chosenSection === 0"
                     :active="activeSection == 0"
                     contentHeight="320px"
                     @click="openSection(0)">
        <CardDetailsForm @proceedReturnUrl="proceedReturnUrl"
                         @submit="chooseSection(0)"
                         @addCardError="handleAddCardError"
                         @success="startAddCard"/>
      </ProperSection>
      <div v-if="!isAndroidContext" class="blocked-funds">
        <p>*Na Twojej karcie zostanie zablokowane 1 zł w celu jej weryfikacji.
          Środki zostaną odblokowane w ciągu godziny</p>
      </div>
    </div>
    <div v-else class="content">
      <header class="main-header">
        <p>Krok 3 z 3</p>
      </header>
      <div class="divider"/>
      <div class="text-header">
        <h1>Wybierz sposób zapłaty</h1>
        <p></p>
      </div>

      <ProperSection :active="activeSection === 0"
                     :chosen="chosenSection === 0"
                     :has-icon="true"
                     :visible="chosenSection === null || chosenSection === 0"
                     class="section-0"
                     contentHeight="150px"
                     subtitle="30 rat 0% oraz pakiet 3 miesiące nie płacisz!"
                     title="Raty 0%"
                     source="eraty.png"
                     @click="openSection(0)">
      </ProperSection>
      <ProperSection :active="activeSection === 1"
                     :chosen="chosenSection === 1"
                     :has-icon="true"
                     :visible="chosenSection === null || chosenSection === 1"
                     class="section-1"
                     contentHeight="150px"
                     subtitle="Zapłać wygodnie za pomocą PayU"
                     title="Płatność jednorazowa"
                     source="PAYU_LOGO_LIME.png"
                     @click="openSection(1)">
      </ProperSection>
      <ProperSection :active="activeSection === 2"
                     :chosen="chosenSection === 2"
                     :visible="chosenSection === null || chosenSection === 2"
                     class="section-2"
                     contentHeight="330px"
                     title="Płatność przelewem"
                     source="/img/PAYU_LOGO_LIME.cdba23cc.png"
                     @click="openSection(2)">
        <div class="fields">
          <h2 class="font-size-middle">Dane do przelewu:</h2>
          <h1 class="font-size-middle">Vocale Sp. z o.o.</h1>
          <h1 class="font-size-middle">Ul. Kalwaryjska 69</h1>
          <h1 class="font-size-middle">30-504 Kraków</h1>
          <h2 class="font-size-middle">Rachunek:
            <h1 class="font-size-middle" style="display: inline">
              20 1870 1045 2083 1065 3974 0001
            </h1>
          </h2>
          <h2 class="font-size-middle">Tytuł:
            <h1 class="font-size-middle" style="display: inline">
              {{ productDetails.description }}, email: {{ loggedInEmail }}
            </h1>
          </h2>
          <h3 class="font-size-small">
            *Pakiet zostanie uruchomiony po zaksięgowaniu płatności
          </h3>
        </div>
      </ProperSection>
      <ProperSection :active="activeSection === 3"
                     :chosen="chosenSection === 3"
                     :visible="chosenSection === null || chosenSection === 3"
                     class="section-3"
                     contentHeight="280px"
                     title="Kod rabatowy"
                     @click="openSection(3)">
        <div v-if="promoCodeFields" class="fields">
          <h2 class="font-size-middle" :class="{ promoErrorInfo: promoError}">Wprowadź swój unikalny kod rabatowy</h2>
          <div v-if="promoError" class="promoError">
            <img src="@/assets/images/errorIcon.svg" alt="" :class="{ bounce: animate }"/>
            <p class="font-size-middle">Błędny kod rabatowy.</p>
          </div>
          <DefaultInputField
              :value="promoCode"
              aria-required="true"
              type="password"
              placeholder="Kod rabatowy"
              @input="handleCodeChange"
              class="promo-code-input"
          />
          <BigButton class="big-button" borderColor="primary" @click="addPromoCode">ZAREJESTRUJ KOD
          </BigButton>
        </div>
        <div v-if="promoCodeAdded" class="promo-code-added">
          <h1 class="font-size-big">SUKCES</h1>
          <h2 class="font-size-middle">Kod został aktywowany</h2>
        </div>
        <div v-if="promoCodeTick" class="check-mark">
          <font-awesome-icon icon="check"/>
        </div>
      </ProperSection>
    </div>
    <AndroidPopup
      v-if="status.finished"
      :type="status.type"
      :title="status.title"
      :message="status.message" />
    <PopupTimer v-if="startTimer"
                title="Zostaniesz przekierowany na stronę banku za"
                :timer="5"
                :isAndroidContext="isAndroidContext"
                :preparedUrl="returnUrl"
                @timerFinished="proceed"/>
    <PopupTimer v-if="startAddCardTimer"
                :preparedUrl="addCardReturnUrl"
                :timer="10"
                :isAndroidContext="isAndroidContext"
                title="Twoja karta zostanie dodana za"
                @timerFinished="proceedAddCard"/>
    <TabFooter v-if="productDetails && !isAndroidContext"
               :name="getProductDetails.name"
               :period="period"
               :price="price"
               :quantity="quantity"
               :buttonEnabled="activeSection === 0 || activeSection === 1 || activeSection === 2"
               :buttonDisplayStop="getProductId === '3' || getProductId === '4'"
               @buttonClicked="preparePayment"/>
    <PageNotFound v-if="loadError" :message="loadError"/>
    <ContentLoader v-if="!productDetails"/>
  </div>
</template>

<script>
import MainPageHeader from '../components/MainPageHeader.vue'
import PageNotFound from '../components/PageNotFound.vue'
import ContentLoader from '../components/ContentLoader.vue'
import TabFooter from '../components/TabFooter.vue'
import CardDetailsForm from '../components/CardDetailsForm.vue'
import ProperSection from '../components/proper/ProperSection.vue'
import { getAuthService } from '@/services/authService'
import { productDatabase } from '@/services/mock/productDatabase'
import { getPaymentService } from '@/services/paymentService'
import PopupTimer from '@/components/PopupTimer'
import { getAndroidContext } from '@/services/sessionProps'
import DefaultInputField from '@/components/input/DefaultInputField.vue'
import BigButton from '@/components/input/BigButton.vue'
import AndroidPopup from '@/components/AndroidPopup.vue'

export default {
  name: 'ProperPage',
  components: {
    PopupTimer,
    MainPageHeader,
    PageNotFound,
    ContentLoader,
    TabFooter,
    CardDetailsForm,
    ProperSection,
    DefaultInputField,
    BigButton,
    AndroidPopup,
  },

  data () {
    return {
      productDetails: {
        key: '',
        name: '',
        price: '',
        period: '',
        quantity: '',
        singlePayment: '',
      },
      tab: null,
      loadError: null,
      activeSection: 0,
      chosenSection: null,
      field5: '',
      loggedInEmail: null,
      price: '',
      period: '',
      quantity: '',
      paymentId: null,
      returnUrl: '',
      addCardReturnUrl: null,
      startTimer: false,
      startAddCardTimer: false,
      isCardAdded: this.checkCardAdded() || false,
      isAndroidContext: false,
      promoCode: '',
      promoError: false,
      animate: false,
      promoCodeFields: true,
      promoCodeAdded: false,
      promoCodeTick: false,
      status: {
        finished: false,
        title: '',
        message: '',
        type: ''
      }
    }
  },

  computed: {
    getProductId() {
      return this.$route.params.productId
    },

    getProductDetails() {
      return productDatabase[this.getProductId]
    },
  },

  mounted () {
    (async () => {
      this.isAndroidContext = getAndroidContext().isAndroidContext()

      if(this.$route.params.product) {
        this.productDetails = this.$route.params.product
      }else if(this.$route.params.productId && this.isAndroidContext) {
        this.productDetails = productDatabase[this.$route.params.productId]
      } else {
        this.$router.replace({ name: 'mainPage' })
      }
      this.price = this.productDetails.price
      this.period = this.getProductDetails.period
      this.quantity = this.productDetails.quantity

      if(document.querySelector('#chat-application') && this.isAndroidContext) {
        document.querySelector('#chat-application').classList.add('hidden-chat')
      }
      const [
        loggedInEmail,
      ] = await Promise.all([
        getAuthService().getLoggedInEmail(),
      ])

      this.loggedInEmail = loggedInEmail
      if (this.loggedInEmail == null) {
        this.$router.replace({
          name: 'logInPage',
        })
      }
    })()

  },

  beforeDestroy() {
    document.querySelector('#chat-application').classList.remove('hidden-chat')
  },

  methods: {
    handleAddCardError() {
      this.status = {
        finished: true,
        type: 'error',
        title: 'Błąd',
        message: 'Wystąpił błąd podczas dodawania karty'
      }
      this.startAddCardTimer = false
    },
    addPromoCode () {
      if (this.promoCode === 'LAHCIM21') {
        this.promoError = false
        this.animate = false
        this.productDetails = productDatabase[parseInt(this.$route.params.id) + 3]
        this.price = this.productDetails.price
        this.period = this.productDetails.period
        this.quantity = this.productDetails.quantity
        this.promoCodeFields = false
        this.promoCodeAdded = true
        setTimeout(() => {
          this.openSection(0)
          this.promoCodeAdded = false
          this.promoCodeTick = true
        }, 2000)

      } else {
        this.promoError = true
        this.animate = true
      }
    },
    handleCodeChange (event) {
      this.promoCode = event
    },
    startAddCard (event) {
      if (event === true) {
        this.startAddCardTimer = true
      }
    },
    proceedReturnUrl (event) {
      if(this.isAndroidContext && event === null) {
        this.status = {
          finished: true,
          type: 'success',
          title: 'SUKCES',
          message: 'Karta została pomyślnie dodana'
        }
      this.startAddCardTimer = false
      } else {
        this.addCardReturnUrl = event
      }
    },
    proceedAddCard () {
      if(sessionStorage.getItem('addCard') === 'true') {
        window.location.href = '#/manage-access?add-card'
      }
      else if (this.addCardReturnUrl === '/') {
        window.location.href = '#/manage-access'
      } else {
        window.location.href = this.addCardReturnUrl
      }
    },
    async checkCardAdded () {
      const checkPayuCard = await getPaymentService().checkPayuCard()

      if (checkPayuCard === null) {
        this.isCardAdded = false
      } else {
        this.isCardAdded = true
      }
      window.scrollTo(0, 0)
    },
    acceptAllInput () {
      if (this.policyStates.some(p => p == false)) {
        this.policyStates = this.policyStates.map(p => true)
      } else {
        this.policyStates = this.policyStates.map(p => false)
      }
    },

    policyInput (index, state) {
      const states = this.policyStates.slice()
      states[index] = !this.policyStates[index]
      this.policyStates = states
    },

    openSection (index) {
      this.activeSection = index

      if (index === 1 || index === 2) {
        this.price = this.getProductDetails.singlePayment
        this.period = ''
        this.quantity = ''
      }
      if (index === 0 || index === 3) {
        this.price = this.productDetails.price
        this.period = this.getProductDetails.period
        this.quantity = this.productDetails.quantity
      }
    },

    async preparePayment () {
      if (this.activeSection === 0) {
        this.startTimer = true
        this.paymentId = await getPaymentService().createInstalmentPayment(`/api/products/${this.productDetails.id}`)
        this.returnUrl = await getPaymentService().getInstalmentPaymentUrl(this.paymentId,
            `/api/products/${getProductId}`)
      } else if (this.activeSection === 1) {
        this.startTimer = true
        this.paymentId = await getPaymentService().createSinglePayment(`/api/products/${this.productDetails.id}`)
        this.returnUrl = await getPaymentService().getPaymentUrl(`/api/products/${this.productDetails.id}`,
            this.paymentId)
      } else if (this.activeSection === 2) {
        await getPaymentService().createPendingOrdinaryTransferPayment(this.productDetails['@id']).then(() => {
          this.$router.push({ name: 'tab3' })
        })

      }
    },
    async proceed () {
      window.location.href = this.returnUrl
    },

    chooseSection (index) {
      this.chosenSection = index
    },

    handleSection1Submit (e) {
      e.preventDefault()
      this.chooseSection(1)
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.TabPage {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  grid-template-areas: 'header'
            'content'
            'footer';
  min-height: 100vh;
}


.MainPageHeader {
  grid-area: header;
}

.Footer {
  grid-area: footer;
}

.content {
  grid-area: content;

  padding: 0 20px;
  margin-top: 140px;
  margin-bottom: 100px;

  // Mobile style
  @media (max-width: $phone-max-width) {
    margin-top: 100px;
  }

  header.main-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 auto;
    max-width: 1300px;

    p {
      font-weight: bold;
    }

    h1 {
      margin-left: 20px;
      color: $primary;
    }
  }

  .text-header {
    padding: 20px 0;
    text-align: center;
    color: white;

    h1 {
      color: $primary;
      margin-bottom: 0;
    }

    h2 {
      color: $primary;
      font-weight: normal;
    }

    .man-acc {
      text-decoration: none;
      color: #d6ae5d;
    }

    // Mobile style
    @media (max-width: $phone-max-width) {

      padding: 10px 0;
      margin-bottom: 20px;

      h1 {
        margin: 0;
      }
    }
  }

  .card-added {
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }

    p {
      color: $red;
      cursor: text;
      margin: 0;

      .man-acc {
        text-decoration: none;
        color: $primary;
        cursor: pointer;
      }

    }
  }

  .section-2 {
    .fields {
      margin-left: 40px;
      margin-right: 40px;
      @media (max-width: 500px) {
        margin-left: 20px;
        margin-right: 20px;
      }

      h1 {
        color: white;
        margin-bottom: 5px;
        margin-top: 0;
      }

      h2 {
        color: $dark-text;
        margin-bottom: 5px;
        margin-top: 0;
      }

      h3 {
        color: $dark-text;
        margin-bottom: 15px;
        margin-top: 15px;
      }
    }

    // Mobile style
    @media (max-width: $phone-max-width) {
      width: 100%;
      min-width: unset;
      padding-bottom: 10px;
    }
  }

  .section-3 {
    .fields {
      margin-left: 70px;
      margin-right: 70px;
      @media (max-width: 500px) {
        margin-left: 20px;
        margin-right: 20px;
      }

      .promoError {
        height: 20px;
        font-weight: normal;
        display: flex;
        width: 100%;
        justify-content: center;
        color: $red;

        div {
          display: flex;
        }

        p {
          margin: 0 0 0 15px;
          display: flex;
          align-items: center;
        }

        img {
          max-width: 1.5rem;
          fill: $red;
        }

        .bounce {
          animation-name: bounce;
          animation-duration: 1.25s;
          animation-iteration-count: 2;
          transition: all 0.25s;
        }

        @keyframes bounce {
          0% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-3px);
          }
          100% {
            transform: translateY(0);
          }
        }
      }

      .promoErrorInfo {
        margin-bottom: 5px;
      }

      .promo-code-input {
        margin-top: 5px;
      }

      h2 {
        text-align: center;
        color: $dark-text;
        margin-bottom: 25px;
        margin-top: 0;
      }

      .BigButton {
        margin-left: 35px;
        @media (max-width: $phone-max-width) {
          margin-left: 25px;
        }
        @media (max-width: 400px) {
          margin-left: 40px;
        }
      }
    }

    .promo-code-added {
      margin: 40px 120px;
      @media (max-width: 500px) {
        margin: 40px 60px;
      }

      h1 {
        text-align: center;
        color: green;
      }

      h2 {
        color: white;
        text-align: center;
        font-weight: normal;
      }
    }

    .check-mark {
      margin: 40px 180px;
      display: block;
      font-size: 5em;
      color: $primary;
      @media (max-width: 500px) {
        margin: 40px 100px;
      }
    }
  }

  .blocked-funds {
    p {
      text-align: center;
      color: $dark-text;
    }
  }

  .divider {
    border-bottom: 1px solid #aaa;
  }

}

.android-content {
  margin-top: 30px;
}
</style>
